<main>
  <loading-overlay [isLoading]="isLoading() > 0"></loading-overlay>

  <div class="content">
    <div class="under__line flex justify-between align-center">
      <h1>{{ 'weightStation.title' | translateWF: 'Weight Station' }} {{ weightStation?.assetId }}</h1>
      <p-button [label]="'weightStation.goToWeightStation' | translateWF: 'Go to Weighing Station'" (onClick)="redirectToWeightStationDetails(weightStation?.assetId)" />
    </div>

    <div class="cs-page-list-grid">
      @if (filterConfig() && showFilters()) {
        <csl-dynamic-filters [filterConfig]="filterConfig()!" [state]="filterState" />
      }

      <p-panel [header]="'weightStation.title' | translateWF: 'Weight Station'">
        <ng-template pTemplate="icons">
          <p-button
            [label]="(showFilters() ? 'Common_Hide_Filters' : 'Common_Show_Filters') | translateWF: (showFilters() ? 'Hide Filters' : 'Show Filters')"
            [icon]="showFilters() ? 'pi pi-filter-slash' : 'pi pi-filter'"
            (click)="showFilters.set(!showFilters())"
            variant="outlined"
            size="small"
          />
        </ng-template>
        <p-card data-variant="compact">
          <p-table [value]="filteredRolls()" selectionMode="single">
            <ng-template pTemplate="header">
              <tr>
                <th>
                  {{ 'weightStation.rollNumber' | translateWF: 'Roll Number' }}
                </th>
                <th>
                  {{ 'weightStation.knittingOrder' | translateWF: 'Knitting Order' }}
                </th>
                <th>
                  {{ 'weightStation.weight' | translateWF: 'Weight' }}
                </th>
                <th>
                  {{ 'weightStation.lastWeightTime' | translateWF: 'Last Weight Time' }}
                </th>
                <th>
                  {{ 'weightStation.quality' | translateWF: 'Quality' }}
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-roll>
              <tr class="cursor-pointer">
                <td>{{ roll.number }}</td>
                <td>{{ roll.knittingOrderNumber }}</td>
                <td>{{ roll.netQuantity | number: '1.2-2' }}</td>
                <td>{{ getLastWeightTime(roll) }}</td>
                <td>{{ rollQualities[roll.rollQuality] }}</td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="5">
                  {{ 'NoRollsFound' | translateWF: 'No rolls found' }}
                </td>
              </tr>
            </ng-template>
          </p-table>
        </p-card>
      </p-panel>
    </div>
  </div>
</main>
